import Index from '../../pages/mitu/drainage/index';

const base = 'drainage';

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/mitu/drainage.js